import React from 'react'
import Button from '@vtex/styleguide/lib/Button'
import { FilterAttributes } from '@/checkout-instore-legacy/components/SearchPage/SearchContent'
import { FormattedMessage } from 'react-intl'

const FiltersError = ({
  term,
  reloadFilters,
}: {
  term: string
  reloadFilters: (term: string, attributes: FilterAttributes) => void
}): JSX.Element => {
  return (
    <span data-testid="search-filters-error">
      <div className="pv3">
        <p>
          <FormattedMessage id="filterLoadError" />
          <strong> {term}</strong>.
        </p>
        <p>
          <FormattedMessage id="filterLoadErrorRetry" />
        </p>
      </div>
      <Button
        testId="search-filters-error-reload"
        variation="primary"
        size="small"
        onClick={reloadFilters}
      >
        <FormattedMessage id="searchTryAgain" />
      </Button>
    </span>
  )
}

export default FiltersError
